<template>
  <div>
    <!-- 附加服务 -->
    <el-dialog :title="$t('message.additionalServices')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="680px" center>
      <div class="option">
        <!-- 列表 -->
        <div class="table">
          <ol>
            <!--附加服务选择  -->
            <li class="flex15">
              {{ $t("message.additionalServiceOptions") }}
            </li>
            <!--附加服务日文  -->
            <li class="flex15">
              {{ $t("message.additionalServicesJapanese") }}
            </li>

            <!--实际收费标准  -->
            <li class="flex15">{{ $t("message.actualCharges") }}</li>
          </ol>
          <ul v-for="(item, index) in optionsList" :key="index" v-show="item.show">
            <!-- 附加服务选择  -->
            <li class="flex15">
              <div class="checkbox">
                <el-checkbox v-model="item.checked">({{ index + 1 }}) {{ item.name }}</el-checkbox>
              </div>
            </li>
            <!--附加服务日文  -->
            <li class="flex15">
              <span>{{ item.name_translate }}</span>
            </li>
            <!--实际收费标准  -->
            <li class="flex15">
              <div class="template">
                {{ item.price }} {{ item.unit }}
              </div>
            </li>
          </ul>
          <!-- 操作 -->
          <div class="operation">
            <el-button type="primary" size="mini" @click="show = !show">
              {{ show ? '收起' : '查看更多OPTION' }}
            </el-button>
          </div>
          <!-- 隐藏显示 -->
          <div :class="{ isShow: show }" class="showList">
            <ul v-for="(item, index) in optionsList" :key="index" v-show="!item.show">
              <!-- 附加服务选择  -->
              <li class="flex15">
                <div class="checkbox">
                  <el-checkbox v-model="item.checked">({{ index + 1 }}) {{ item.name }}</el-checkbox>
                </div>
              </li>
              <!--附加服务日文  -->
              <li class="flex15">
                <span>{{ item.name_translate }}</span>
              </li>
              <!--实际收费标准  -->
              <li class="flex15">
                <div class="template">
                  {{ item.price }} {{ item.unit }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import NP from 'number-precision' //NP.strip 处理浮点数
export default {

  data() {
    return {
      show: false,
      NP,
      optionsList: [],
      dialogVisible: false,
    };
  },
  created() {

  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.$api.siteConfiguration.optionList().then((res) => {
          res.data.forEach((item, index) => {
            if (index < 9) {
              item.show = true
            } else {
              item.show = false
            }
          })
          this.optionsList = res.data;
        });
      }
    },
  },
  methods: {
    // 保存
    save() {
      this.$parent.datas.condition.option = []
      this.optionsList.forEach(item => {
        if (item.checked) {
          this.$parent.datas.condition.option.push({
            name: item.name,
            checked: item.checked,
            num: item.num
          })
          this.$forceUpdate()
          this.dialogVisible = false
        }
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.table {
  margin-bottom: 20px;
  max-height: 650px;
  overflow-y: auto;

  ol {
    display: flex;
    height: 40px;
    background: #f8f8f8;
    border-radius: 4px 4px 0px 0px;
    justify-content: center;
    align-items: center;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;

    li {
      height: 40px;
      text-align: center;
    }
  }

  ul {
    display: flex;
    padding: 10px 0;

    .total {
      width: 70%;
      text-align: center;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .flex2 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .checkbox {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px;

    .input {
      width: 160px;
      margin-left: 10px;
    }
  }

  .template {
    display: flex;
    flex-wrap: wrap;
    line-height: 32px;

    .input {
      width: 140px;
      margin-right: 10px;
    }
  }
}

.operation {
  margin-top: 10px;


  .el-button {
    margin-right: 220px;
  }
}

.showList {
  transition: all 0.3s;
  height: 0;
  overflow: hidden;
}

.isShow {
  height: auto;

}
</style>